/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RepresentationModelObject } from '../../models/representation-model-object';

export interface GetLinks$Params {
}

export function getLinks(http: HttpClient, rootUrl: string, params?: GetLinks$Params, context?: HttpContext): Observable<StrictHttpResponse<RepresentationModelObject>> {
  const rb = new RequestBuilder(rootUrl, getLinks.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RepresentationModelObject>;
    })
  );
}

getLinks.PATH = '/';
